import { z } from 'zod';

export const BankAccountSchema = z.object({
    bankCode: z.string().optional(),
    agency: z.string().optional(),
    account: z.string().optional(),
    digit: z.string().optional(),
    pixKey: z.string().optional(),
});

export type BankAccount = z.infer<typeof BankAccountSchema>; 